import { AxiosRequestConfig } from 'axios'
import {
  Municipality as Data,
  MunicipalityCollection as Collection,
} from '@/typings/api/Municipality'

import { BaseApiAuth } from '@/api/BaseApiAuth'


export class AteUtilsApi extends BaseApiAuth<Data, Collection> {
  protected readonly endpoint = 'ate/utils';

  public normalize(data: Record<string, unknown>, config?: AxiosRequestConfig) {
    const path = 'normalize/'
    const [url] = this.getUrl(path, data)
    return this.request('POST', url, { data, ...config })
  }
}
